
import Vue from 'vue';
import { TTSCategory as TTSCategoryData } from '@root/modules/podcast/types/podcast';
import TTSCategory from '@root/modules/podcast/components/TTSCategory.vue';
import buildCategoryUrl from '@root/modules/category/utils/buildCategoryUrl';
import { Category } from '@root/common/types/fragment';
import Swiper from '@core/components/UI/swiper/Swiper.vue';
import LinkHandler from '@core/components/helpers/LinkHandler.vue';
import isMobileView from '@root/common/utils/isMobileView';

type Variables = { category: Category; domain: string | string[]; fakeDomainEnabled: boolean };

interface Props {
  data: TTSCategoryData[];
}

interface Data {
  isMobileView: boolean;
  swiperOptions: Record<string, any>;
}

interface Computed {
  items: TTSCategoryData[];
}

interface Methods {
  getCategoryWithHref: (variables: Variables) => TTSCategoryData;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    TTSCategory,
    Swiper,
    LinkHandler,
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      isMobileView: false,
      swiperOptions: {
        spaceBetween: 24,
        initialSlide: 0,
        autoplay: false,
        loop: false,
        slidesPerView: 2.5,
        slidesPerGroup: 1,
        pagination: {
          enabled: false,
        },
        navigation: {
          enabled: false,
        },
        scrollbar: {
          enabled: false,
        },
        simulateTouch: false,
        breakpoints: {
          768: {
            freeMode: false,
            slidesPerView: 4,
            slidesPerGroup: 4,
          },
          1230: {
            freeMode: false,
            slidesPerView: 6,
            slidesPerGroup: 6,
          },
        },
      },
    };
  },
  computed: {
    items() {
      let data = [...this.data];

      if (this.data.length) {
        const fakeDomainEnabled = this.$config.FAKE_DOMAIN_ENABLED;
        const categoriesWithHref = data.map((category: Category) => {
          const { domain } = this.$channelConfig('settings');
          return this.getCategoryWithHref({ category, domain, fakeDomainEnabled });
        });

        data = categoriesWithHref;
      }

      return data;
    },
  },
  methods: {
    getCategoryWithHref({ category, domain, fakeDomainEnabled }: Variables): TTSCategoryData {
      const href = buildCategoryUrl({ category, domain, fakeDomainEnabled });
      const podcastWithHref = { ...category, href };

      return podcastWithHref;
    },
  },
  mounted() {
    this.isMobileView = isMobileView();
  },
});
